<forge-icon-button id="popover-trigger" class="button grid-icon-button" aria-label="Search Grid Data">
    <forge-tooltip placement="bottom">Search</forge-tooltip>
    <forge-icon name="search"></forge-icon>
    <forge-focus-indicator circular inward></forge-focus-indicator>
</forge-icon-button>
<forge-popover #popover anchor="popover-trigger" placement="bottom" position-strategy="fixed" [shift]="false"
    hide="anchor-hidden" (forge-popover-toggle)="toggleSearchPopover($event)">
    <forge-scaffold>
        <div slot="header" style="padding: var(--forge-spacing-medium);" class="forge-typography--heading2">Search all
            columns</div>
        <div slot="body" style="width: 300px;">
            <div style="padding: var(--forge-spacing-medium);">
                <forge-text-field show-clear density="small" (forge-text-field-clear)="clearFilter()">
                    <input #searchFilter type="text" tabindex="0" placeholder="Search" [(ngModel)]="searchText"
                        (keydown)="searchKeyDown($event)" aria-label="search">
                </forge-text-field>
            </div>
            <div class="igx-column-actions__buttons">
                <button type="button" igxButton igxRipple role="button" class="igx-button igx-button--flat"
                    (click)="cancel()">Cancel</button>
                <button type="button" igxButton igxRipple role="button" class="igx-button igx-button--flat"
                    (click)="applySearch()" [disabled]="!hasSearchFilter">Search</button>
            </div>
        </div>
    </forge-scaffold>
</forge-popover>